import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth } from "@tm/utils"
import { HistorySummary } from "./models"

export function getHistorySummary(vin: string, vehicleId: string): Promise<Array<HistorySummary>> {
    const url = `${WebserviceUrl.DataStoreFastServiceHistories}/GetHistoryInfoList`
    const body = { VINNumber: vin, vehicleId }

    return ajaxAuth({ url, body }).then((data) => {
        return data?.result || []
    })
}
